const PLATFORM_HOSTS = new Set(['marketbooksolution.com', 'www.marketbooksolution.com'])

function normalizeHost(host) {
  if (!host || typeof host !== 'string') return ''
  const trimmed = host.toLowerCase().trim()
  if (!trimmed) return ''
  const withoutTrailingDot = trimmed.endsWith('.') ? trimmed.slice(0, -1) : trimmed
  return withoutTrailingDot.replace(/^www\./, '')
}

function normalizePath(pathname = '/') {
  if (!pathname || typeof pathname !== 'string') return '/'
  if (!pathname.startsWith('/')) return `/${pathname}`
  return pathname
}

function normalizeImageUrl(value) {
  if (!value || typeof value !== 'string') return ''

  const trimmed = value.trim().replace(/\s+/g, '')
  if (!trimmed) return ''
  if (trimmed.startsWith('data:') || trimmed.startsWith('blob:')) return trimmed
  if (trimmed.startsWith('/')) return trimmed
  if (/^(https?:)?\/\//i.test(trimmed)) {
    try {
      const parsed = new URL(trimmed.startsWith('//') ? `https:${trimmed}` : trimmed)
      parsed.search = ''
      parsed.hash = ''
      return parsed.toString()
    } catch {
      return trimmed.replace(/[?#].*$/, '')
    }
  }

  return trimmed.replace(/[?#].*$/, '')
}

function isPlatformBrandingUrl(value) {
  if (!value || typeof value !== 'string') return false
  const normalized = normalizeImageUrl(value)
  if (!normalized || normalized.startsWith('/') || normalized.startsWith('data:') || normalized.startsWith('blob:')) {
    return false
  }

  try {
    const parsed = new URL(normalized.startsWith('//') ? `https:${normalized}` : normalized)
    return PLATFORM_HOSTS.has(parsed.hostname) || parsed.hostname.endsWith('.marketbooksolution.com')
  } catch {
    return false
  }
}

function resolveSeoImageUrl(website) {
  const seo = website?.seo || {}
  const candidates = [
    website?.logo?.url,
    website?.favicon?.url,
    seo.socialImage,
    seo.ogImage,
    seo.twitterImage,
    seo.image
  ]

  const rejected = []
  for (const candidate of candidates) {
    const normalized = normalizeImageUrl(candidate)
    if (!normalized) continue
    if (isPlatformBrandingUrl(normalized)) {
      rejected.push(normalized)
      continue
    }
    return normalized
  }

  if (rejected.length > 0) {
    console.warn('[PUBLIC-WEBSITE-SEO] Platform branding rejected for public website metadata', {
      websiteId: website?._id,
      slug: website?.slug,
      rejected: rejected.slice(0, 5)
    })
  }

  return ''
}

function buildCanonicalUrl({ host, protocol = 'https', pathname = '/', search = '' }) {
  const normalizedHost = normalizeHost(host)
  const normalizedPath = normalizePath(pathname)
  const baseUrl = `${protocol}://${normalizedHost}`
  // Tracking and query variants should not create separate canonical URLs.
  // The server-rendered public HTML follows the same stable path-only policy.
  return `${baseUrl}${normalizedPath}`
}

function buildPublicSiteSeo({ website, host, pathname, search, protocol = 'https' }) {
  const isPlatformHost = PLATFORM_HOSTS.has(normalizeHost(host)) || normalizeHost(host).endsWith('.marketbooksolution.com')
  const baseHost = isPlatformHost ? 'marketbooksolution.com' : normalizeHost(host)
  const canonicalUrl = buildCanonicalUrl({ host: baseHost, protocol, pathname, search })
  const title = website?.seo?.metaTitle || website?.name || (isPlatformHost ? 'MarketBookSolution' : 'Website')
  const description = website?.seo?.metaDescription || website?.description || (isPlatformHost ? 'Create and manage modern websites with MarketBookSolution, a modern website builder platform.' : 'Welcome to this site.')
  const keywords = website?.seo?.metaKeywords || ''
  const image = resolveSeoImageUrl(website)

  return {
    title,
    description,
    keywords,
    canonicalUrl,
    ogUrl: canonicalUrl,
    ogTitle: title,
    ogDescription: description,
    ogImage: image,
    twitterCard: 'summary_large_image',
    twitterTitle: title,
    twitterDescription: description,
    twitterImage: image,
    robots: 'index,follow'
  }
}

export { buildPublicSiteSeo, normalizeHost }
